/**
 * Checks if a date string is valid
 * @param {string} value - The date string to check
 * @returns {boolean} - True if the date string is valid, false otherwise
 */

export function isValidDateString(value) {
  const date = new Date(value)
  return !isNaN(date.getTime())
}
